import { render, staticRenderFns } from "./ManagementPotential.vue?vue&type=template&id=2466cd84"
import script from "./ManagementPotential.vue?vue&type=script&lang=js"
export * from "./ManagementPotential.vue?vue&type=script&lang=js"
import style0 from "./ManagementPotential.vue?vue&type=style&index=0&id=2466cd84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
